import { DefaultId } from "./Globals"

export type LanguageId = string

export type Language = {
    languageId: LanguageId;
    localDisplayName: string;
}

export type TranslatedContent = { [language: string]: string }

export type TranslationDictionary = { [term: string]: TranslatedContent }

export const AvailabeLanguagesIds: LanguageId[] = ["da", DefaultId]
export const AvailabeLanguages: Language[] = [
    {
        languageId: DefaultId,
        localDisplayName: "English"
    },
    {
        languageId: "da",
        localDisplayName: "Dansk"
    }
]

export default Language